import type {Media} from '../types';

export const sortMediaAttachment = (a: Media, b: Media): number => {
  if (a.subType === b.subType && a.subType === 'ATTACHMENT') {
    if (a.fileNr === b.fileNr) {
      return 0;
    }

    return a.fileNr < b.fileNr ? 1 : -1;
  }

  return 0;
};
